import PropTypes from 'prop-types';
import React from 'react';
import { MobileDetection } from '@reverbdotcom/discovery-ui';
import { RCTextWithIcon, RCButton } from '@reverbdotcom/commons/src/rc';
import FacebookAltSvg from '@reverbdotcom/commons/design-system/icons/core/facebook-alt.svg?component';
import TwitterSvg from '@reverbdotcom/commons/design-system/icons/core/twitter.svg?component';
import CopySvg from '@reverbdotcom/commons/design-system/icons/core/clipboard.svg?component';

const COPIED_FADE_DELAY_MS = 1500;

class ReferAFriendSocialButtons extends React.Component {
  static propTypes = {
    // The current user's referral link
    referralLink: PropTypes.string.isRequired,
  };

  static defaultProps = {
    isMobileBrowser: MobileDetection.isMobileBrowser(),
  };

  state = { copied: false };

  render() {
    return (
      <section>
        {this.referralLink()}
        <div className="mt-1">
          <div className="g-container">
            {this.facebookShareButton()}
            {this.twitterShareButton()}
            {this.copyButton()}
          </div>
          {this.copiedMessage()}
        </div>
      </section>
    );
  }

  referralLink = () => {
    if (this.props.isMobileBrowser) {
      return (
        <div className="referral-link panel bd-1 bd--offwhite">{this.props.referralLink}</div>
      );
    }
    return (
      <div className="align-center bd-color-primary bd-1 bd-rounded ptb-1">
        {this.props.referralLink}
      </div>
    );
  };

  trackSelectLinkEventAndCopyText = (event) => {
    this.copyText(event);
  };

  copyText = (event) => {
    event.preventDefault();

    navigator.clipboard.writeText(this.props.referralLink);
    this.setState({
      copied: true,
    });
  };

  copiedMessage = () => {
    if (this.state.copied) {
      return (
        <p ref="copiedMessage" className="copied-to-clipboard-tooltip mt-half mb-0">
          {I18n.t('js.referAFriendSocialButtons.copied')}
        </p>
      );
    }
  };

  facebookShareButton = () => (
    <div className="g-col-4 g-col-mobile-12 mobile-mb-1">
      <a
        href={this.props.facebookLink}
        target="_blank"
        className="referral-facebook-share"
        rel="noopener noreferrer"
      >
        <RCTextWithIcon
          svgComponent={FacebookAltSvg}
          placement="left"
          title={I18n.t('js.referAFriendSocialButtons.facebook')}
        >
          {I18n.t('js.referAFriendSocialButtons.share')}
        </RCTextWithIcon>
      </a>
    </div>
  );

  twitterShareButton = () => (
    <div className="g-col-4 g-col-mobile-12 mobile-mb-1">
      <a
        href={this.props.twitterLink}
        target="_blank"
        className="referral-twitter-share"
        rel="noopener noreferrer"
      >
        <RCTextWithIcon
          svgComponent={TwitterSvg}
          placement="left"
          title={I18n.t('js.referAFriendSocialButtons.twitter')}
        >
          {I18n.t('js.referAFriendSocialButtons.tweet')}
        </RCTextWithIcon>
      </a>
    </div>
  );

  copyButton = () => {
    if (!this.props.isMobileBrowser) {
      return (
        <div className="g-col-4 g-col-mobile-12 mobile-mb-1">
          <RCButton fullWidth onClick={this.copyText} size="small" variant="secondary">
            <RCTextWithIcon svgComponent={CopySvg} placement="left">
              {I18n.t('js.referAFriendSocialButtons.copy')}
            </RCTextWithIcon>
          </RCButton>
        </div>
      );
    }
  };

  componentDidUpdate() {
    if (this.refs.copiedMessage) {
      $(this.refs.copiedMessage).show().delay(COPIED_FADE_DELAY_MS).fadeOut();
    }
  }
}

export default ReferAFriendSocialButtons;
